/** biome-ignore-all lint/style/useNamingConvention: GA4 reserved param names */
import type { AnalyticsEventParamsType, IAnalyticsAdapter } from '@repo/analytics';
import { getGtag } from './get-gtag';

export const ga4GtagAdapter: IAnalyticsAdapter = {
  track: (eventName: string, params?: AnalyticsEventParamsType): void => {
    getGtag()?.('event', eventName, params ?? {});
  },
  identify: (userId: string): void => {
    getGtag()?.('set', { user_id: userId });
  },
  setUserProperty: (key: string, value: string): void => {
    getGtag()?.('set', 'user_properties', { [key]: value });
  },
  reset: (): void => {
    getGtag()?.('set', { user_id: null });
  },
  trackScreen: (screenName: string, extra?: AnalyticsEventParamsType): void => {
    getGtag()?.('event', 'page_view', {
      page_path: screenName,
      page_title: typeof document === 'undefined' ? screenName : document.title,
      page_location: typeof window === 'undefined' ? screenName : window.location.href,
      ...extra,
    });
  },
};
